import { api } from "../../api";
import { handleResponse, RequestOptions } from "../types";
import { getCookie } from "../../helpers/utils";
import { cookieToken } from "../../constants";
import {payloadBetDetails} from "../../store/agent/globalBetList";

const getGlobalBetList = (data: any) => {
  const authenticity_token = getCookie(cookieToken);

  const payload = {
    ...data.payload,
    authenticity_token: authenticity_token,
  };

  return fetch(`${api.agent.globalBetList.list}`, {...RequestOptions('POST', JSON.stringify(payload))})
    .then(handleResponse)
    .then(
      data => {
        return data;
      }
    )
    .catch((error) => {
      return error
    });
};

const getBetDetails = (data: payloadBetDetails) => {
  const authenticity_token = getCookie(cookieToken);

  const endpoint = `${api.agent.globalBetList.betDetails.replace('{betId}', data.betId)}`;

  const payload = {
    date: data.date,
    playerId: data.playerId,
    authenticity_token: authenticity_token,
  };

  return fetch(
    `${endpoint}`, {...RequestOptions('POST', JSON.stringify(payload))})
    .then(handleResponse)
    .then(
      data => {
        return data;
      }
    )
    .catch((error) => {
      return error
    });
};

const downloadGlobalBetList = (data: any) => {
  const authenticity_token = getCookie(cookieToken);

  const endpoint = `${api.agent.globalBetList.download}`;

  const payload = {
    ...data.payload,
    authenticity_token: authenticity_token,
  };

  return fetch(endpoint, {...RequestOptions('POST', JSON.stringify(payload))})
    .then(handleResponse)
    .then(
      data => {
        return data;
      }
    )
    .catch((error) => {
      return error
    });
};

const getGlobalBetListOptions = () => {
  const authenticity_token = getCookie(cookieToken);

  const endpoint = `${api.agent.globalBetList.options}${authenticity_token ? `?authenticity_token=${authenticity_token}` : ''}`;

  return fetch(endpoint, {...RequestOptions('GET')})
    .then(handleResponse)
    .then(
      data => {
        return data;
      }
    )
    .catch((error) => {
      return error
    });
};

export const globalBetListService = {
  getGlobalBetList,
  getBetDetails,
  downloadGlobalBetList,
  getGlobalBetListOptions
};
